import { postApiGalaxyServer, getApiGalaxyServer, deleteApiGalaxyServer } from 'services';
import {
  CreateTeamPayload,
  DeleteBatchTimeEntriesPayload,
  ExportDeletedWorkPlanCsvParams,
  FetchTeamConfigsPayload,
  FetchTeamEmployeeStatisticsPayload,
} from 'TeamModule/types';

export const createTeam = (params: CreateTeamPayload, config = {}, token: string) =>
  postApiGalaxyServer('/rails_api/signup', params, config, token);

export const getTeams = (config: Record<string, unknown>, token = '') =>
  getApiGalaxyServer('/rails_api/teams/all', config, token);

export const deleteBatchTimeEntries = (
  _ = {},
  body: DeleteBatchTimeEntriesPayload,
  config: Record<string, unknown>,
  token = '',
) => deleteApiGalaxyServer('/rails_api/time_entries/batch_delete', body, config, token);

export const exportDeletedWorkPlanCsv = (
  params: ExportDeletedWorkPlanCsvParams,
  config = {},
  token: string,
) => {
  return postApiGalaxyServer('/rails_api/data_recovery', params, config, token);
};

export const fetchTeamConfigs = ({
  params,
  token,
  config,
}: BaseApiParams<FetchTeamConfigsPayload>) => {
  return getApiGalaxyServer('/integrations_api/configs/teams', { ...config, params }, token);
};

export const fetchTeamEmployeeStatistics = ({
  params,
  token,
  config,
}: BaseApiParams<FetchTeamEmployeeStatisticsPayload>) => {
  return getApiGalaxyServer(
    '/rails_api/statistics/employee_statistics',
    { ...config, params: params as any },
    token,
  );
};
